import { AxiosInstance } from 'axios'

export interface GetContactsArgs {
  locale: string
}

type ContactsDto = {
  data: {
    id: number
    attributes: {
      how_to_find_us_header: string | null
      how_to_find_us_text: string | null
      address: string | null
      phone: string | null
      email: string | null
      time: string | null
      map_url: string | null
      button_text: string | null
      location_header: string | null
      marker_lat: string | null
      marker_lng: string | null
      marker_text: string | null
      marker_title: string | null
      image: {
        data: {
          id: number
          attributes: {
            url: string
            alternativeText: string | null
            caption: string | null
          }
        } | null
      }
    }
  }
  meta: Record<string, unknown>
}

export const getContacts = async (
  client: AxiosInstance,
  { locale }: GetContactsArgs,
): Promise<ContactsDto['data']['attributes']> => {
  const path = `/contacts-page-block`
  const params = {
    locale: locale,
    sort: { createdAt: 'desc' },
    fields: [
      'how_to_find_us_header',
      'how_to_find_us_text',
      'address',
      'phone',
      'email',
      'time',
      'map_url',
      'button_text',
      'location_header',
      'marker_lat',
      'marker_lng',
      'marker_text',
      'marker_title',
    ],
    populate: {
      fields: ['*'],
      image: { fields: ['url', 'alternativeText', 'caption'] },
    },
  }
  return (await client.get<ContactsDto>(path, { params })).data.data.attributes
}
